import React from 'react';
import { Box, Text } from '@chakra-ui/react';

const NotFound = () => {
  return (
    <Box>
      <Text fontSize="2xl">404: Not Found</Text>
      <Text mt={4}>
        The page you are looking for has been consumed by the void. Dare you search again, or flee in terror?
      </Text>
    </Box>
  );
};

export default NotFound;
